<template>
  <div class="navigation">
    <figure class="navigation__pic">
      <img src="/images/common/menu.webp" alt="">
    </figure>
    <nav class="navigation__list">
      <div class="navigation__list__item">
        <figure class="navigation__list__item__logo">
          <a href="/"><img src="/images/common/logo.webp" alt="キッズ・パワー株式会社" /></a>
          <figcaption>キッズ・パワー株式会社</figcaption>
        </figure>
        <ul class="navigation__list__item__ul">
          <li><a href="/company/">企業情報</a></li>
          <li><a href="/office/">事業所情報</a></li>
          <li><a href="/search/">事業所を探す</a></li>
          <li><a href="/recruit/">採用情報</a></li>
          <li><a href="/news/">お知らせ</a></li>
          <li><a href="/contact/">お問い合わせ</a></li>
          <li><a href="/privacy/">プライバシーポリシー</a></li>
        </ul>
      </div>
      <div class="navigation__list__item">
        <figure class="navigation__list__item__logo">
          <a href="/olinace/index/"><img src="/images/common/olinace_logo_o.webp" alt="キッズ・パワー株式会社" /></a>
          <figcaption>児童発達支援／放課後等デイサービス</figcaption>
        </figure>
        <ul class="navigation__list__item__ul o">
          <li><a href="/olinace/class/">教室紹介</a></li>
          <li><a href="/olinace/howto/">ご利用方法</a></li>
          <li><a href="/olinace/staff/">指導員紹介</a></li>
          <li><a href="/olinace/faq/">よくあるご質問</a></li>
          <li><a href="/olinace/effects/">お子様の効果例</a></li>
          <li><a href="/olinace/schedule/">一日のスケジュール</a></li>
          <li><a href="/olinace/access/">アクセス</a></li>
          <li><a href="/news/">ブログ</a></li>
          <li><a href="/olinace/contact/">お問い合わせ</a></li>
        </ul>
      </div>
      <div class="navigation__list__item">
        <figure class="navigation__list__item__logo">
          <a href="/e-olinace/index/"><img src="/images/common/olinace_logo_b.webp" alt="キッズ・パワー株式会社" /></a>
          <figcaption>就労継続支援A／B型事業</figcaption>
        </figure>
        <ul class="navigation__list__item__ul b">
          <li><a href="/e-olinace/office/">事業所紹介</a></li>
          <li><a href="/e-olinace/flow/">ご利用方法</a></li>
          <li><a href="/e-olinace/staff/">支援員紹介</a></li>
          <li><a href="/e-olinace/faq/">よくあるご質問</a></li>
          <li><a href="/e-olinace/access/">アクセス</a></li>
          <li><a href="/news/">お知らせ</a></li>
          <li><a href="/e-olinace/contact/">お問い合わせ</a></li>
        </ul>
      </div>
    </nav>
  </div>
</template>

<style lang="scss" scoped>
.navigation{
  width: 100%;
  height: 100%;
  position: fixed;
  background: module.$white;
  z-index: 999;
  &__pic{
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border: module.$white 1rem solid;
    border-radius: 2rem;
    overflow: hidden;
    img{
      width: 100%;
      height: 100%;
      object-fit: cover;
      object-position: top center;
      animation: showPic 800ms module.$ease forwards;
      @keyframes showPic {
        0%{
          opacity: 0;
          transform: scale(1.1);
        }
        100%{
          opacity: 1;
          transform: scale(1);
        }
      }
    }
  }
  &__list{
    position: absolute;
    left: 0;
    bottom: 0;
    width: 100%;
    height: auto;
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 1.2rem;
    padding: 3.2rem;
    &__item{
      background: module.$white;
      border-radius: 1rem;
      box-shadow: 0 0 3.2rem rgba(module.$normal,.16);
      padding: 1.6rem 2.4rem 2.4rem;
      opacity: 0;
      @for $i from 1 through 5{
        &:nth-child(#{$i}){
          animation: showListitems 800ms $i*80ms module.$ease forwards;
        }
      }
      @keyframes showListitems {
        0%{
          transform: translateY(-10%);
          opacity: 0;
        }
        100%{
          transform: translateY(0%);
          opacity: 1;
        }
      }
      &__logo{
        width: 100%;
        margin: 0 auto;
        text-align: center;
        img{
          width: 12rem;
          height: 4rem;
          max-width: 100%;
          object-fit: contain;
          object-position: center;
        }
        figcaption{
          font-size: 1.08rem;
          margin: .24rem 0 0;
        }
      }
      &__ul{
        display: grid;
        grid-template-columns: repeat(2, 1fr);
        gap: 1.6rem;
        grid-row-gap: .64rem;
        margin: 1.6rem 0 0;
        padding: 1.6rem 0 0;
        border-top: module.$border 1px solid;
        &.o{
          li{
            a{
              background-image: url("data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGhlaWdodD0iMjRweCIgdmlld0JveD0iMCAtOTYwIDk2MCA5NjAiIHdpZHRoPSIyNHB4IiBmaWxsPSIjZTc5MDBjIj48cGF0aCBkPSJtNTIxLjIzLTQ4MC0xMjMgMTIzTDQ0MC0zMTQuMjMgNjA1Ljc3LTQ4MCA0NDAtNjQ1Ljc3IDM5OC4yMy02MDNsMTIzIDEyM1ptLTQxLjE2IDM4MHEtNzguODQgMC0xNDguMjEtMjkuOTJ0LTEyMC42OC04MS4yMXEtNTEuMzEtNTEuMjktODEuMjUtMTIwLjYzUTEwMC00MDEuMSAxMDAtNDc5LjkzcTAtNzguODQgMjkuOTItMTQ4LjIxdDgxLjIxLTEyMC42OHE1MS4yOS01MS4zMSAxMjAuNjMtODEuMjVRNDAxLjEtODYwIDQ3OS45My04NjBxNzguODQgMCAxNDguMjEgMjkuOTJ0MTIwLjY4IDgxLjIxcTUxLjMxIDUxLjI5IDgxLjI1IDEyMC42M1E4NjAtNTU4LjkgODYwLTQ4MC4wN3EwIDc4Ljg0LTI5LjkyIDE0OC4yMXQtODEuMjEgMTIwLjY4cS01MS4yOSA1MS4zMS0xMjAuNjMgODEuMjVRNTU4LjktMTAwIDQ4MC4wNy0xMDBaIi8+PC9zdmc+");
              &:hover{
                color: module.$orange;
              }
            }
          }
        }
        &.b{
          li{
            a{
              background-image: url("data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGhlaWdodD0iMjRweCIgdmlld0JveD0iMCAtOTYwIDk2MCA5NjAiIHdpZHRoPSIyNHB4IiBmaWxsPSIjMGY2Y2Q0Ij48cGF0aCBkPSJtNTIxLjIzLTQ4MC0xMjMgMTIzTDQ0MC0zMTQuMjMgNjA1Ljc3LTQ4MCA0NDAtNjQ1Ljc3IDM5OC4yMy02MDNsMTIzIDEyM1ptLTQxLjE2IDM4MHEtNzguODQgMC0xNDguMjEtMjkuOTJ0LTEyMC42OC04MS4yMXEtNTEuMzEtNTEuMjktODEuMjUtMTIwLjYzUTEwMC00MDEuMSAxMDAtNDc5LjkzcTAtNzguODQgMjkuOTItMTQ4LjIxdDgxLjIxLTEyMC42OHE1MS4yOS01MS4zMSAxMjAuNjMtODEuMjVRNDAxLjEtODYwIDQ3OS45My04NjBxNzguODQgMCAxNDguMjEgMjkuOTJ0MTIwLjY4IDgxLjIxcTUxLjMxIDUxLjI5IDgxLjI1IDEyMC42M1E4NjAtNTU4LjkgODYwLTQ4MC4wN3EwIDc4Ljg0LTI5LjkyIDE0OC4yMXQtODEuMjEgMTIwLjY4cS01MS4yOSA1MS4zMS0xMjAuNjMgODEuMjVRNTU4LjktMTAwIDQ4MC4wNy0xMDBaIi8+PC9zdmc+");
              &:hover{
                color: module.$blue;
              }
            }
          }
        }
        li{
          font-size: clamp(1rem, 1.8vmin, 2rem);
          a{
            color: module.$normal;
            display: block;
            position: relative;
            background-image: url("data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGhlaWdodD0iMjRweCIgdmlld0JveD0iMCAtOTYwIDk2MCA5NjAiIHdpZHRoPSIyNHB4IiBmaWxsPSIjZTcwMDBmIj48cGF0aCBkPSJtNTIxLjIzLTQ4MC0xMjMgMTIzTDQ0MC0zMTQuMjMgNjA1Ljc3LTQ4MCA0NDAtNjQ1Ljc3IDM5OC4yMy02MDNsMTIzIDEyM1ptLTQxLjE2IDM4MHEtNzguODQgMC0xNDguMjEtMjkuOTJ0LTEyMC42OC04MS4yMXEtNTEuMzEtNTEuMjktODEuMjUtMTIwLjYzUTEwMC00MDEuMSAxMDAtNDc5LjkzcTAtNzguODQgMjkuOTItMTQ4LjIxdDgxLjIxLTEyMC42OHE1MS4yOS01MS4zMSAxMjAuNjMtODEuMjVRNDAxLjEtODYwIDQ3OS45My04NjBxNzguODQgMCAxNDguMjEgMjkuOTJ0MTIwLjY4IDgxLjIxcTUxLjMxIDUxLjI5IDgxLjI1IDEyMC42M1E4NjAtNTU4LjkgODYwLTQ4MC4wN3EwIDc4Ljg0LTI5LjkyIDE0OC4yMXQtODEuMjEgMTIwLjY4cS01MS4yOSA1MS4zMS0xMjAuNjMgODEuMjVRNTU4LjktMTAwIDQ4MC4wNy0xMDBaIi8+PC9zdmc+");
            background-position: left center;
            background-repeat: no-repeat;
            background-size: clamp(1.2rem, 2.2vmin, 2.4rem);
            padding: 0 0 0 clamp(1.6rem, 3vmin, 3rem);
            &:hover{
              color: module.$main;
              &:before{
                width: 100%;
                right: auto;
                left: 0;
              }
            }
            &:before{
              content: '';
              width: 0;
              height: 1px;
              background: module.$white;
              position: absolute;
              right: 0;
              bottom: .16rem;
              transition: width 200ms module.$ease;
            }
          }
        }
      }
    }
  }
}
</style>


<script>
import Btn from './Btn.vue'
export default {
  components: {
    Btn: Btn,
  },
}
</script>
